import React from "react";
import { Button, CircularProgress } from "@mui/material";

interface LoadingButtonProps extends React.ComponentProps<typeof Button> {
  isLoading?: boolean;
}

const LoadingButton = ({
  isLoading,
  children,
  ...props
}: LoadingButtonProps) => {
  return (
    <Button
      {...props}
      disabled={isLoading || props.disabled}
      startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
    >
      {children}
    </Button>
  );
};

export default LoadingButton;
